var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "countdown-text" }, [
    _vm._v("\n  Did not receive the code?\n  "),
    _vm.count > 0
      ? _c("span", [
          _vm._v("Wait "),
          _c("strong", [
            _vm._v(
              _vm._s(_vm.count) +
                " " +
                _vm._s(_vm.count > 1 ? "seconds" : "second")
            ),
          ]),
          _vm._v(" to resend."),
        ])
      : _c("span", [
          _c(
            "button",
            {
              staticClass: "btn btn-xs btn-primary",
              attrs: { disabled: _vm.count > 0 || _vm.disabled },
              on: { click: _vm.resend },
            },
            [_vm._v("Resend")]
          ),
          _vm._v("\n\n    or\n\n    "),
          _c("button", {
            staticClass: "btn btn-xs btn-primary",
            attrs: { disabled: _vm.count > 0 || _vm.disabled },
            domProps: { textContent: _vm._s(_vm.requestChangeText) },
            on: {
              click: function ($event) {
                return _vm.$emit("requestChange")
              },
            },
          }),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }